import type {Result, UseCase} from 'framework';
import type {ProductError} from '../../domain/errors';
import type {ResolveResult} from '../../domain/resolve-result';
import type {ProductRepository} from '../ports/product.repository';

export type ResolveProductInput = {
  readonly barcode: string;
};

export class ResolveProduct implements UseCase<[ResolveProductInput], ResolveResult> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: ResolveProductInput): Promise<Result<ResolveResult, ProductError>> {
    return this.repository.resolve(input.barcode);
  }
}
